import { render } from "./businessDetail.vue?vue&type=template&id=28c0bdf2&scoped=true&ts=true"
import script from "./businessDetail.vue?vue&type=script&lang=ts"
export * from "./businessDetail.vue?vue&type=script&lang=ts"

import "./businessDetail.vue?vue&type=style&index=0&id=28c0bdf2&lang=scss&scoped=true"

import exportComponent from "D:\\项目\\template\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c0bdf2"]])

export default __exports__